import { render, staticRenderFns } from "./employerConfidentialFiles.vue?vue&type=template&id=c962cfce&scoped=true"
import script from "./employerConfidentialFiles.vue?vue&type=script&lang=js"
export * from "./employerConfidentialFiles.vue?vue&type=script&lang=js"
import style0 from "./employerConfidentialFiles.vue?vue&type=style&index=0&id=c962cfce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c962cfce",
  null
  
)

export default component.exports